import React from "react";
import styled from "styled-components";
import theme from "../style/theme";
import { FluidImg } from "./FluidImg"

const Wrapper = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  margin: 15vh 0;
  padding: 0;
  background-color: ${props => props.backgroundColor};
  z-index: 0;
  &::before {
    content: "${props => props.decorationText}";
    position: absolute;
    bottom: -1rem;
    left: 1rem;
    font-size: 4rem;
    font-weight: bold;
    font-family: 'Montserrat', serif;
    font-style: italic;
    letter-spacing: .13em;
    color: ${theme.palette.lightGray};
    z-index: -1;
  }
  @media screen and (max-width: ${(props) => props.breakpoints - 1}px) {
    flex-direction: column;
    margin: 15vh 0 5vh;
    padding: 0 0 2rem 0;
    &:last-of-type {
      margin: 20vh 0 10vh;
    }
    &::before {
      top: auto;
      bottom: -1rem;
      font-size: 2.5rem;
    }
  }
`

const ImageWrapper = styled.div`
  width: 45%;
  padding: 2rem 2rem 2rem 4rem;
  box-sizing: border-box;
  .gatsby-image-wrapper {
    bottom: 5rem;
    box-shadow: 0 5px 15px #999;
  }
  @media screen and (max-width: ${(props) => props.breakpoints - 1}px) {
    width: 80%;
    padding: 0 0;
    margin: auto;
  }
`

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 55%;
  margin: auto;
  padding: 2rem 4rem 2rem 2rem;
  box-sizing: border-box;
  @media screen and (max-width: ${(props) => props.breakpoints - 1}px) {
    width: 80%;
    padding: 0 0;
  }
`

const Title = styled.h3`
  position: relative;
  width: 100%;
  font-size: 1.4rem;
  margin: 0;
  padding: 0;
  &::before {
    position: absolute;
    content: "";
    top: 50%;
    right: 0;
    height: 1px;
    display: block;
    margin: 0 auto;
    text-align: center;
    border-top: 1px solid #1b1f22;
    width: 100px;
  }
  @media screen and (max-width: ${(props) => props.breakpoints - 1}px) {
    text-align: center;
    &::before {
      top: -100px;
      right: 0;
      left: 0;
      height: 50px;
      display: block;
      margin: 0 auto;
      text-align: center;
      border-left: 1px solid #1b1f22;
      border-top: none;
      width: 1px;
    }
  }
`

const Description = styled.p`
  font-size: 0.9rem;
`

export const ProductCard = ({fileName, backgroundColor, decorationText, title, description, breakpoints}) => {
  return (
    <Wrapper breakpoints={breakpoints} backgroundColor={backgroundColor} decorationText={decorationText}>
      <ImageWrapper breakpoints={breakpoints}>
        <FluidImg fileName={fileName} />
      </ImageWrapper>
      <TitleWrapper breakpoints={breakpoints}>
        <Title breakpoints={breakpoints}>{title}</Title>
        <Description>{description}</Description>
      </TitleWrapper>
    </Wrapper>
  )
}